import { getCsrfToken } from "@/lib/csrf"
import { toast } from "@/components/ui/sonner"

// Single-source DELETE for a deletable domain row (a note or
// a follow-up) shared by every surface that can delete one —
// the activity feed, the deal Next steps section, the Today
// page, the inbox rail (CON-253). Fires the request, toasts
// on the outcome, and resolves to a success boolean so the
// caller can gate optimistic cleanup / closing the confirm.
//
// The caller owns any prop reload AFTER a success — the
// server serializer stays the single source of truth, so we
// don't ship the mutated row on the wire. Hard delete; no
// Undo (resurrecting the row would need its own endpoint and
// would race the rich-text body on notes).
export async function deleteRow(
  url: string,
  successMessage: string,
): Promise<boolean> {
  try {
    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "X-CSRF-Token": getCsrfToken(),
      },
      credentials: "same-origin",
    })
    if (!response.ok) {
      toast.error("We couldn't delete that. Please try again.")
      return false
    }
    toast(successMessage)
    return true
  } catch {
    toast.error("We couldn't delete that. Please try again.")
    return false
  }
}
